import { createApiCall } from 'lib/base';

const LINK_NHSV_ACCOUNT_API_ID = 'DASHBOARD/LINK_NHSV_ACCOUNT_API';

const apiCall = createApiCall(
  LINK_NHSV_ACCOUNT_API_ID,
  (params: { account_number: string; name: string; email: string; phone: string }) => ({
    endpoint: '/api/admin/nhsv/link-account',
    method: 'POST',
    body: params,
  })
);

export default apiCall;
